import { render, staticRenderFns } from "./CollectionUserDealCount.vue?vue&type=template&id=3ce87580&scoped=true&"
import script from "./CollectionUserDealCount.vue?vue&type=script&lang=js&"
export * from "./CollectionUserDealCount.vue?vue&type=script&lang=js&"
import style0 from "./CollectionUserDealCount.vue?vue&type=style&index=0&id=3ce87580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce87580",
  null
  
)

export default component.exports